/** 售后申请原因 */
import { AfterSaleMode } from '@/types';

export const afterSaleApplyCauseConfigs: Record<AfterSaleMode, { text: string; id?: string }[]> = {
  [AfterSaleMode.refundOnly]: [
    { text: '拍错/多拍/不喜欢' },
    { text: '未按约定时间发货', id: 'late-delivery' },
    { text: '协商一致退款' },
    { text: '地址/电话填错了' },
    { text: '其他' },
  ],

  [AfterSaleMode.refundForReturnedGoods]: [
    { text: '拍错/多拍/不喜欢' },
    { text: '未按约定时间发货', id: 'late-delivery' },
    { text: '做工粗糙/有瑕疵' },
    { text: '商品破损/少件' },
    { text: '商品描述不符' },
    { text: '商家发错货' },
    { text: '质量问题' },
    { text: '退运费' },
    { text: '其他' },
  ],

  [AfterSaleMode.exchangeGoods]: [
    { text: '商家发错商品' },
    { text: '大小/颜色/型号不合适' },
    { text: '商品损坏' },
    { text: '其他' },
  ],
};
